// extracted by mini-css-extract-plugin
export default {"cls1":"LtjZCk2GwjGc4tHBdA5w","cls2":"GJd6Yi78ZEk1l1wZracA LtjZCk2GwjGc4tHBdA5w"};